import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { deleteTeamUnavailability, updateTeamUnavailability,} from "store/actions"; // Assuming these actions exist
import CreateTeamUnAvailability from "./CreateTeamUnAvailability";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { formatDateTimeToAmPm } from "helpers/dateFormat_helper";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const TeamUnAvailabilityTable = ({ List ,loading,teamId}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId,setDeleteId] = useState();
  const [openModal,setOpenModal] = useState()
  const [confirmAction,setConfirmAction] = useState();

  const permissions2 = JSON.parse(localStorage?.getItem('permissions'));
  const hasEditPermission = permissions2.some(item => item?.permissionName === "Edit Team Unavailability");
  const hasDeletePermission = permissions2.some(item => item?.permissionName === "Delete Team Unavailability");

  const handleDelete = (unavailabilityId) => {
    dispatch(deleteTeamUnavailability(unavailabilityId,teamId))
    setDeleteId('')
    setOpenModal(false);
    setConfirmAction(false);
  };
  
  useEffect(()=>{
    if(deleteId && confirmAction){
      handleDelete(deleteId);
    }
  },[deleteId,confirmAction])

  const columns = useMemo(
    () => [
      {
        header: 'Team Name',
        accessorKey: 'teamName', // Assuming you will use teamName to display the team
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Start Date/Time',
        accessorKey: 'startDateTime',
        enableColumnFilter: false,
        enableSorting: true,
        cell:({row})=>(
          <span>
            {formatDateTimeToAmPm(row.original.startDateTime)}
          </span>
        )
      },
      {
        header: 'End Date/Time',
        accessorKey: 'endDateTime',
        enableColumnFilter: false,
        enableSorting: true,
        cell:({row})=>(
          <span>
            {formatDateTimeToAmPm(row.original.endDateTime)}
          </span>
        )
      },
      {
        header: 'Reason',
        accessorKey: 'reason',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Unavailability Type',
        accessorKey: 'unavailabilityType',
        enableColumnFilter: false,
        enableSorting: true,
      },
      ...(hasEditPermission || hasDeletePermission ?[{
        header: 'Actions',
        id: 'actions', // Unique id for this column
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData);
            setIsOpen(true);
            console.log('Edit clicked for row:', rowData);
          };

          return (
            <div className="d-flex gap-2">
              {permissions2?.map(item=>item?.permissionName)?.includes("Edit Team Unavailability") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions2?.map(item=>item?.permissionName)?.includes("Delete Team Unavailability") && <Button
                color="danger"
                onClick={()=>{setDeleteId(row?.original?.unavailabilityId); setOpenModal(true);}}
                className="mr-2"
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
    ] : []),
    ],
    []
  );

  const handleSubmit = (data) => {
    dispatch(updateTeamUnavailability(data));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // Meta title
  document.title = "Team Unavailability | Admin Dashboard";

  return (
    <>
      <ConfirmationModal  okText={"Confirm"} onCancel={()=>{setDeleteId(''); setOpenModal(false); }} onOk={()=>{setConfirmAction(true);}} isVisible={openModal} title="Delete Team UnAvailability" content='Are You Sure You Want to Delete the Team unavailability'/>
      <CreateTeamUnAvailability
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        teamId={teamId}
      />
      <div className="">
        <div className="container-fluid">
          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Team UnAvailabilities"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default TeamUnAvailabilityTable;
